import { isValidEmail } from '@functions/validations'
import managementState from '@models/User/management'
import editorState from '@models/User/editor'
import providerState from '@models/User/provider'
import qcState from '@models/User/qc'
import productionManagerState from '@models/User/production_manager'
import specialistState from '@models/User/specialist'
import agentState from '@models/User/agent'
import clientAdminState from '@models/User/client_admin'

const state = {
  id: null,
  annotation: {},
  contact: {},
  email: '',
  employment: '',
  flags: [],
  jobtrack_username: '',
  name: '',
  roles: [],
  username: '',
  // roles
  agent: agentState,
  client_admin: clientAdminState,
  editor: editorState,
  management: managementState,
  production_manager: productionManagerState,
  provider: providerState,
  qc: qcState,
  specialist: specialistState,
}

export const requiredFields = [
  { key: 'email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
  { key: 'username' },
  { key: 'name' },
  { key: 'employment' },
  { key: 'roles' },
]

export default state
